import WithSidebar from 'Layout/WithSidebar';
import image from 'images/small-images-inside-text/plants.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItems from 'components/ProductItems';
import { vegetablesFull } from 'components/ProductItems/mockData';
import Filter from 'components/Filter';
import Banner from 'components/Banner';
import bannerImage from 'images/crop-nutrition-programs.jpg';
import { cropNutritionPrograms } from 'components/Filter/mockData';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';

const CropNutritionPrograms = () => {
    return (
        <>
            <Banner title="Crop nutrition programs" image={bannerImage} buttonText="Choose a crop" />

            <section className="container">
                <div className="inner-container type-3">
                    <div className="main-text-container">
                        <LabelButton>agricultural solutions</LabelButton>
                        <GradientText>
                            Learn how to care for your plants, providing them with
                            <img src={image} alt="decor" />
                            <em>proper nutrition for maximum crop yield</em>
                        </GradientText>
                    </div>
                </div>

                <WithSidebar Sidebar={<Filter data={cropNutritionPrograms} />}>
                    <div className="box">
                        <ProductItems data={vegetablesFull} />
                    </div>
                </WithSidebar>
            </section>

            <DefaultForm />
        </>
    );
};

export default CropNutritionPrograms;
